import React from 'react';
import MessageDialog, { IMessageDialogProps } from '@srm/ui/message-dialog';
import { AttachActionsService } from '@services/actions/AttachActionsService';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { IDeleteAttachProps } from './IDeleteAttachProps';

export const DeleteAttachModal: React.FC<IDeleteAttachProps> = (props: IDeleteAttachProps) => {
    const { errorText, isBusy, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        submit: () => new AttachActionsService(props.docId, '-1').deleteAttach(props.attachId),
    });

    const getMessage = () => {
        const attachIdsSplit = props.attachId.split(',').filter((item) => item);
        if (attachIdsSplit.length <= 1) {
            const parts = props.attachId.split('_');
            const rowData = Array.isArray(props.rowData) ? props.rowData[0] : props.rowData;
            return parts.length === 1
                ? `Удалить файл '${rowData.fields.AttachmentTitle ?? rowData.fields.AttachmentFileName}'?`
                : `Удалить версию файла ${rowData.fields.AttachmentTitle ?? rowData.fields.AttachmentFileName} (версия ${parts[1]})?`;
        } else {
            return 'Удалить выбранные файлы?';
        }
    };

    const messageString: string = getMessage();

    const messageBoxProp: IMessageDialogProps = {
        header: 'Удаление',
        message: messageString,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        size: props.modalSize,
        onConfirm: okClick,
        onCancel: cancelClick,
    };

    return <MessageDialog {...messageBoxProp} loading={isBusy} errorText={errorText} />;
};
